// One immutable public marketing object, not a general media-host allowlist.
// Kept together so the browser source and document CSP cannot drift.
export const HOME_HERO_VIDEO_PATH = "site/hero-car-mobile-10ff186a623e.mp4";
export const HOME_HERO_VIDEO_CDN_SOURCE =
  `https://pub-b0c8d82c3e244a2fbf1133bf122e76fa.r2.dev/marketing/${HOME_HERO_VIDEO_PATH}`;
